// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoAtom_wrapper__marLI","wistia-wrapper":"VideoAtom_wistia-wrapper__Tp7y_","caption":"VideoAtom_caption__Il4PA"};